import { lazy } from 'react';
import { Outlet, Route } from 'react-router-dom';
import MainOutlet from '../MainOutlet';
import HesRoutes from '../routes/Hes';
import VeeRoutes from '../routes/Vee';
import useGetIdToken from '@/hooks/useGetIdToken';
import useGetPermissionRoutesObj from '@/hooks/useGetPermissionRoutesObj';
import NfmsRoutes from '../routes/Nfms';
import PrepaidEngineRoutes from '../routes/PrepaidEngine';
import SatRoutes from '../routes/Sat';
import EnergyAccountingRoutes from '../routes/EnergyAccounting';

const Home = lazy(() => import('@/pages/home'));
const HesAuth = lazy(() => import('@/pages/hes-auth'));
const NotFound = lazy(() => import('@/pages/not-found'));
const AccessControlPanel = lazy(() => import('@/pages/access-control-panel'));
const NotImplemented = lazy(() => import('@/pages/not-implemented'));
const Profile = lazy(() => import('@/pages/profile'));
const DLMSAccessControlPanel = lazy(
  () => import('@/pages/access-control-panel/dlms')
);

const getProtectedRoutes = () => {
  const { permissions, unimplementedPermissions } = useGetPermissionRoutesObj();
  const decodedIdToken = useGetIdToken();

  return (
    <Route element={<MainOutlet />}>
      <Route
        index
        element={<Home />}
      />

      <Route
        path="profile"
        element={<Profile />}
      />

      {permissions.includes('/hes') && (
        <>
          <Route
            path="hes-auth"
            element={<HesAuth />}
          />
          {HesRoutes}
        </>
      )}

      {permissions.includes('/vee') && VeeRoutes}
      {permissions.includes('/nfms') && NfmsRoutes}
      {permissions.includes('/sat') && SatRoutes}
      {permissions.includes('/energy-accounting') && EnergyAccountingRoutes}

      {permissions.includes('/prepaid-engine') && PrepaidEngineRoutes}
      {decodedIdToken && decodedIdToken['cognito:groups']?.[0] === 'admin' && (
        <Route
          path="access-control-panel"
          element={<Outlet />}>
          <Route
            index
            element={<AccessControlPanel />}
          />
          {import.meta.env.VITE_DLMS_BASE_URL && (
            <Route
              path="dlms"
              element={<DLMSAccessControlPanel />}
            />
          )}
        </Route>
      )}
      {unimplementedPermissions.map((path) => (
        <Route
          key={path}
          path={path}
          element={<NotImplemented />}
        />
      ))}
      <Route
        path="*"
        element={<NotFound />}
      />
    </Route>
  );
};

export default getProtectedRoutes;
